module.exports = __webpack_public_path__ + "img/KO.93a7e88d.png";